/**
 * Staging cannot render GFM tables (ReactMarkdown, no remark-gfm).
 * Convert pipe tables to a monospace pre block before markdown parse.
 */

const TABLE_ROW = /^\s*\|.*\|\s*$/;
const TABLE_DIVIDER = /^\s*\|?\s*:?-{3,}:?\s*(\|\s*:?-{3,}:?\s*)+\|?\s*$/;

export function fallbackMarkdownTables(content) {
  if (typeof content !== 'string' || !content.includes('|')) {
    return typeof content === 'string' ? content : '';
  }
  const lines = content.split('\n');
  const out = [];
  let i = 0;
  while (i < lines.length) {
    if (isTableStart(lines, i)) {
      const chunk = [];
      while (i < lines.length && (TABLE_ROW.test(lines[i]) || TABLE_DIVIDER.test(lines[i]))) {
        chunk.push(lines[i]);
        i += 1;
      }
      out.push('```');
      out.push(formatTable(chunk));
      out.push('```');
      continue;
    }
    out.push(lines[i]);
    i += 1;
  }
  return out.join('\n');
}

function isTableStart(lines, index) {
  if (!TABLE_ROW.test(lines[index])) return false;
  const next = lines[index + 1];
  return Boolean(next && (TABLE_DIVIDER.test(next) || TABLE_ROW.test(next)));
}

function cells(line) {
  return line
    .trim()
    .replace(/^\|/, '')
    .replace(/\|$/, '')
    .split('|')
    .map((cell) => cell.trim());
}

function formatTable(rows) {
  const body = rows.filter((line) => !TABLE_DIVIDER.test(line)).map(cells);
  if (!body.length) return rows.join('\n');
  const width = Math.max(...body.map((row) => row.length));
  const padded = body.map((row) => {
    const next = [...row];
    while (next.length < width) next.push('');
    return next;
  });
  const colWidths = [];
  for (let c = 0; c < width; c += 1) {
    colWidths[c] = Math.max(3, ...padded.map((row) => (row[c] || '').length));
  }
  return padded
    .map((row) => row.map((cell, c) => (cell || '').padEnd(colWidths[c], ' ')).join('  |  '))
    .join('\n');
}
